import { createSelector } from 'reselect';

const selectservices = (state: any) => state.services;


export const selectservicesCurrentItem = createSelector([selectservices], (services) => services.current);

export const selectservicesListItems = createSelector([selectservices], (services) => services.list);

export const selectItemById = (itemId: any) =>
    createSelector(selectservicesListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectservicesQueryItems = createSelector([selectservices], (services) => services.query);

export const selectservicesCreatedItem = createSelector([selectservices], (services) => services.create);

export const selectservicesUpdatedItem = createSelector([selectservices], (services) => services.update);

export const selectservicesReadItem = createSelector([selectservices], (services) => services.read);

export const selectservicesDeletedItem = createSelector([selectservices], (services) => services.delete);

export const selectservicesSearchedItems = createSelector([selectservices], (services) => services.search);

export const selectservicesItemsCount = createSelector([selectservices], (services) => services.count);

export const selectservicesItemsFilter = createSelector([selectservices], (services) => services.filter);